const pgPrivacyLink = 'https://www.plusgrade.com/policy/privacy/';

export default pgPrivacyLink;
